import Axios from "axios";
import {
    SET_PROJECT_TYPE_LIST,
    UNSET_PROJECT_TYPE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateProjectType, getProjectTypeList } from "@/store/api";
// initial state
const state = {
  getProjectTypeList: [],
};

const getters = {
  getProjectTypeList(state) {
    return state.getProjectTypeList;
  },
};

const mutations = {
  [SET_PROJECT_TYPE_LIST](state, data) {
    state.getProjectTypeList = data;
  },
  [UNSET_PROJECT_TYPE_LIST](state) {
    state.getProjectTypeList = [];
  },

};

const actions = {

  saveUpdateProjectType({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProjectType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getProjectTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProjectTypeList, data)
        .then(function (response) {
          commit('SET_PROJECT_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PROJECT_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};